// Copyright (c) 2022, Harpiya Software Technologies


if (harpiya.require) {
	harpiya.require("file_uploader.bundle.js");
} else {
	harpiya.ready(function () {
		harpiya.require("file_uploader.bundle.js");
	});
}
